import React, { useState } from 'react';
import { Table,Card } from 'react-bootstrap';
import Loader from '../Reusable/loader';
import axios from "axios";
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";
function ServiceClaimStatus() {
    const [serviceno, setServiceno] = useState("");
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleServiceChange = (event) => {
        setServiceno(event.target.value.trim());
    };

    const handleSubmitForm = (event) => {
        event.preventDefault();
        if (!serviceno) {
            Swal.fire('Error', 'Please enter a service number', 'error');
            return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append("doc_no", serviceno);

        axios.post(BASE_URL + '/serviceClaimStatus', formData)
            .then((response) => {
                setIsLoading(false);
                if (response.data && response.data.serviceStatus) {
                    setItems(response.data.serviceStatus);
                } else {
                    ///Swal.fire('No Data', 'No results found for the provided service number.', 'info');
                    Swal.fire('No Data', response.data.data ,'info');
                    setItems([]);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                Swal.fire('Error', 'An error occurred while fetching data.', 'error');
                console.error(error);
            });
    };

    return (
        <div className='container mt-5'>
            <div className='text-center'>
                
                <h1>Claim Details</h1>
                <form onSubmit={handleSubmitForm}>
                <div class="row">
                <div class="col-md-3">
                   <label for="serviceno" style={{ textAlign: 'left' }}><b>Service Claim No:</b></label>
                   </div>
                   <div className='col-md-5'>
                   <input type="text" value={serviceno} className='form-control' onChange={handleServiceChange} id='serviceno' />
                </div>
                <div className="col-md-4">
                <div className="row">
                   <button type="submit" class="btn btn-primary btn-md btn-block">View</button>
                </div>
                </div>
             </div>
             </form>
                <br />
                {isLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
					<br/>
					<br/>
					<br/>
					<br/>
					<br/>
					<center>
                        <Loader />
						</center>
                    </div>
                ) : (
                    items.length > 0 ? (
                        //<Card>
                        <Table responsive="sm"  className="table table-hover border border-2" style={{ borderCollapse: 'separate', borderSpacing: '3px', }} >
                            <thead className="table-success">
                                <tr  style={{ border: '2px solid #69899F', color: '#3E5260', padding: '10px' }}>
                                    {Object.keys(items[0]).map(key => (
                                        <th key={key}>{key.replace(/_/g, ' ').toUpperCase()}</th>
                                    ))}
                                </tr>
                            </thead>
                            { items.length > 0 ? (
                            <tbody>
                                {items.map((item, index) => (
                                    <tr key={index}  style={{ border: '2px solid #69899F', color: '#3E5260', padding: '10px' }}>
                                        {Object.entries(item).map(([key, value], i) => (
                                            <td key={i}>
													{key.toLowerCase().includes("status") ? (
													    <span>{value}</span>
													) : key === "TOTAL_AMOUNT" ? (
														new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(value)
												    ) : value !== null && value !== undefined ? (
														value.toString().trim()
													) : (
														""
													)}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                            ): (
                                <div className="text-center" style={{ width: '100%' }}>No data available</div>
                            )}
                        </Table>
                        //</Card>
                    ) : (
                        <div></div>
                    )
                )}
            </div>
        </div>
    );
}

export default ServiceClaimStatus;
